import { render, staticRenderFns } from "./OptHoldTotal.vue?vue&type=template&id=098f63b5"
import script from "./OptHoldTotal.vue?vue&type=script&lang=js"
export * from "./OptHoldTotal.vue?vue&type=script&lang=js"
import style0 from "./OptHoldTotal.vue?vue&type=style&index=0&id=098f63b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports